module.exports = __webpack_public_path__ + "img/phone-icon.97a16217.svg";